import { StatusFilter } from "../clientDashboardEvents";

/**
 * Shown in place of the performance block when the selected status matches no campaign
 * (PO review of MPN-1964).
 *
 * Every chart answers an empty scope with its zero-row shape, so without this the Ended view
 * of a client whose campaigns are all live reads 0 engagements, 0%, "No target actions
 * configured." and two flat lines — a campaign that performed badly rather than a filter that
 * found nothing. That is the same misreading the ticket opens with, one filter along.
 *
 * The condition is the filter tree, not the charts: a real campaign with no conversions yet
 * must keep its zeros.
 */
const MESSAGE: Record<Exclude<StatusFilter, "ALL">, string> = {
    LIVE: "No live campaigns.",
    ENDED: "No ended campaigns.",
};

export default function NoCampaignsNotice({ status }: { status: Exclude<StatusFilter, "ALL"> }) {
    return (
        <div className="dash-notice">
            <div className="dash-notice__title">{MESSAGE[status]}</div>
            <div className="dash-notice__body">
                Choose All Statuses to see every campaign for this organization.
            </div>
        </div>
    );
}
